module.exports = __webpack_public_path__ + "img/backgroud.4bb8d400.png";